import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {useGetSessionUser} from '../../../../core/use-get-session-user';

type Props = {
    onClose: () => void;
};

export function GetStarted(props: Props) {
    const {user} = useGetSessionUser();

    return (
        <OnboardingBody title='Getting started with Nutshell’s tracking snippet'>
            <p>
                VisitorIQ will start tracking companies as soon as Nutshell’s tracking snippet is
                active.
            </p>
            {user && user.permissions.canAccessSetup && (
                <p>
                    To begin, set up tracking {/* @ts-expect-error */}
                    <Link as={RoutedLink} to='/setup/tracking-snippet' onClick={props.onClose}>
                        here
                    </Link>
                    .
                </p>
            )}
        </OnboardingBody>
    );
}
